<template>
  <d-row class="page-header no-gutters pb-4">
    <d-col cols="12">
      <span class="text-uppercase page-subtitle">{{ pageSubtitle }}</span>
    </d-col>
    <d-col cols="12" class="text-left mb-0">
      <h3 class="page-title">{{ pageTitle }}</h3>
    </d-col>
  </d-row>
</template>

<script>
export default {
  name: "page-header",
  computed: {
    pageTitle() {
      return this.$store.state.app.pageTitle;
    },
    pageSubtitle() {
      return this.$store.state.app.pageSubtitle;
    },
  },
  methods: {
    handleClick() {
      this.$eventHub.$emit("toggle-sidebar");
    }
  }
};
</script>
